import { Form, Select } from 'antd';
import { useMemo } from 'react';
import { fieldIsRequired } from '../../constants/constants';
import { selectHerePlaceholder } from '../../constants/translations';

const birthYearList = (currentYear: number): number[] => {
  const yearList = Array.from(
    { length: 30 },
    (_, index) => currentYear - index,
  );
  return yearList.toReversed();
};

export const BirthYearSelection = () => {
  const currentYear = new Date().getFullYear();
  const relevantYearLisct = useMemo(
    () => birthYearList(currentYear),
    [currentYear],
  );

  return (
    <Form.Item
      label="Mokinio gimimo metai"
      name={['registration', 'birthYear']}
      rules={[fieldIsRequired]}
    >
      <Select placeholder={selectHerePlaceholder} showSearch={true}>
        {relevantYearLisct.map((birthYear, index) => (
          <Select.Option key={`period_item_${index + 1}`} value={birthYear}>
            {birthYear}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};
